import type { Contract, ContractsResponse, Depot, DepotsResponse } from "@/api/contracts/types";
import type { Document, DocumentsResponse } from "@/api/documents/types";

export type LicencePlate = {
  unterscheidungszeichen: string | null,
  erkennungszeichen: string | null,
  erkennungsnummer: number | null,
  abschliessendeszeichen: 'H' | 'E' | null,
};

// matches laravel/app/Enums/ContractSource.php
export const ContractSource = {
  MANUAL: 'manual',
  AI_EXTRACTION: 'ai-extraction',
  BANKS_API: 'banks-api',
} as const;

export type ContractSource = typeof ContractSource[keyof typeof ContractSource];

export type ContractData = {
  sparte_id: number | null,
  gesellschaft_id: number | null,
  vertragsnummer: string | null,
  beginn: string | null, // date in php
  ablaufdatum: string | null, // date in php
  beitrag: number | null,
  zahlweise: number | null,
  kennzeichen: LicencePlate
  notiz?: string | null
  source: ContractSource | null
};

// references professionalworks/protected/models/vertrag/ContractsPaymentType.php
export const ContractsPaymentType = {
  SINGLE_PAYMENT: 5,
  MONTHLY: 4,
  QUARTERLY: 3,
  SEMIANNUAL: 2,
  ANNUAL: 1,
  BEITRAGSFREI: 7,
  OTHER: 6,
} as const

export const ContractPaymentTypeRaw = {
  BEITRAGSFREI: 'beitragsfrei',
  OTHER: 'sonstiges',
  SINGLE_PAYMENT: 'Einmalbetrag',
  MONTHLY: 'monatlich',
  QUARTERLY: 'vierteljährlich',
  SEMIANNUAL: 'halbjährlich',
  ANNUAL: 'jährlich',
} as const

export type ContractPaymentTypeRaw = (typeof ContractPaymentTypeRaw)[keyof typeof ContractPaymentTypeRaw];

// references professionalworsk/protected/models/vertrag/ContractStatus.php
export enum ContractState {
  AKTIV = 1,
  STORNIERT = 2,
  BEITRAGSFREI = 3,
  SONSTIGE = 4,
  RUHEND = 5,
}

export const ContractPaymentName = {
  [ContractsPaymentType.BEITRAGSFREI]: "Beitragsfrei",
  [ContractsPaymentType.OTHER]: "sonstiges",
  [ContractsPaymentType.SINGLE_PAYMENT]: "Einmalig",
  [ContractsPaymentType.MONTHLY]: "Monatlich",
  [ContractsPaymentType.ANNUAL]: "Jährlich",
  [ContractsPaymentType.SEMIANNUAL]: "Halbjährlich",
  [ContractsPaymentType.QUARTERLY]: "Vierteljährlich",
}

export const PaymentTypeOptions = Object.values(ContractsPaymentType).map(key => {
  return {
    label: ContractPaymentName[key],
    value: key
  }
})

export type NestedContracts = Omit<ContractsResponse, 'contracts'> & { contracts: Contract[] };
export type NestedDepots = Omit<DepotsResponse, 'depots'> & { depots: Depot[] };
export type NestedDocuments = Omit<DocumentsResponse, 'documents'> & { documents: Document[] };

export type StringMap = { [key: string]: string };
